/**
 * グループ会社ページ用のスクリプト
 */
if (is_route('schedule.index')) {
    // スクリプト読込
    require('./Base/schedule_base.index');

    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        schedule_base_event_set();
        schedule_base_setting_event_set();
    });
}
